import React from 'react'

export default function InputFile({id, label, error, script, disabled, accept}){
    return (
        <>
            <div className="font-semibold">
                {label && <label htmlFor={id}>{label}</label>}
            </div>
            <div className="mt-2">
                <input id={id} type="file" disabled={disabled} accept={accept} className={`w-full border border-gray-300 rounded-lg p-2 ${error ? 'border-red-700' : ''} focus:outline-none focus:border-primary focus:ring-primary focus:ring-1 rounded-md border border-gray-300 w-auto
                    file:mr-5 file:py-1 file:px-3 file:border-0
                    file:text-xs file:font-medium file:rounded-md
                    file:bg-primary file:text-white
                    hover:file:cursor-pointer`} {...script} />
                <label className='text-red-700 italic'>{error}</label>
            </div>
        </>
    )
}